import {ArchiSmallServices} from './archismall.service';
import {AlertService} from './ui/alert.service';
import {googleAPI} from '../third/googleAPI';
import {saveAs} from '../third/fileSaver';
import {IHttpResponse, IPromise} from 'angular';

export class FileService {
  static $inject: string[] = [
    'ArchiSmallServices',
    'AlertService'
  ];

  constructor(
    private archiSmallServices: ArchiSmallServices,
    private alertService: AlertService,
  ) {
  }

  downloadFile(url: any): void {
    let urlVal = encodeURI(url);
    // corregge gli url che hanno un punto in mezzo (rompono i path, perché lo validano come navigazione relativa)
    urlVal = urlVal.replace(/\/\./g, '%2F.');

    this.archiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
      .then((response) => {
          let googleAPIToken = googleAPI.getAccessToken();
          this.download(googleAPIToken, urlVal);
        },
        (error) => {
          this.archiSmallServices.getGoogleAPIToken()
            .then((response: any) => {
                googleAPI.setAccessToken(response.accessToken);
                let googleAPIToken = googleAPI.getAccessToken();
                this.download(googleAPIToken, urlVal);
              },
              (error) => {
                this.alertService.alert('error', error);
              });
        });
  }

  downloadCsv(request: IPromise<IHttpResponse<any>>) {

    request.then((response: any) => {
      if (response.fileContent === '') {
        this.alertService.alert('info', 'Allegato non disponibile');
        return;
      }
      const base64str = response.fileContent;

      // decode base64 string, remove space for IE compatibility
      const binary = atob(base64str.replace(/\s/g, ''));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      var view = new Uint8Array(buffer);
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }

      var blob = new Blob([view], {type: 'text/' + response.fileType});

      saveAs(blob, response.fileName);
    }, (error) => {
      this.alertService.alert('error', error);
    });
  }

  downloadAttachment(item: any) {
    if (item.hasAttachment === false) {
      return;
    }
    const path = item.filePathXML || item.file_path_xml;
    if (path === undefined) {
      this.alertService.alert('info', 'Allegato non disponibile');
      return;
    }
    this.archiSmallServices.getFatturaAttachment(path)
      .then((response: any) => {
        console.log(response);
        if (response.fileContent === '') {
          this.alertService.alert('info', 'Allegato non disponibile');
          return;
        }
        const base64str = response.fileContent;

        // decode base64 string, remove space for IE compatibility
        const binary = atob(base64str.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }

        var blob = new Blob([view], {type: 'application/' + response.fileType});

        saveAs(blob, response.fileName);
      }, (error) => {
        this.alertService.alert('error', error);
      });
  }

  downloadTDocFile(item: any, type: string): void {
    if (item._id === undefined) {
      this.alertService.alert('info', 'Documento non disponibile');
      return;
    }
    if (type === 'RDV') {
      this.archiSmallServices.getRdvFile(item._id)
        .then((response: any) => {
          if (response.fileContent === '') {
            this.alertService.alert('info', 'File non disponibile');
            return;
          }
          const base64str = response.fileContent;

          // decode base64 string, remove space for IE compatibility
          const binary = atob(base64str.replace(/\s/g, ''));
          const len = binary.length;
          const buffer = new ArrayBuffer(len);
          var view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          var blob = new Blob([view], {type: 'application/' + response.fileType});
          saveAs(blob, response.fileName);
        }, (error) => {
          this.alertService.alert('error', error);
        });
    }
  }

  private download(googleAPIToken: string, urlVal: string) {
    // add parametro per forzare attachment (download)
    const forceDownloadParam = encodeURIComponent('attachment');
    const url = `https://storage.googleapis.com/${urlVal}?access_token=${googleAPIToken}&response-content-disposition=${forceDownloadParam}`;

    window.open(url, '_blank');
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/file.service.ts